import type { SectionNavContent } from "../types";

export const sectionNav: SectionNavContent = {
  ariaLabel: "Page sections",
  labels: {
    hero: "Overview",
    consortium: "Consortium",
    platform: "Platform",
    "works-for": "Works for",
    features: "Features",
    security: "Data Security",
    models: "Models",
    resources: "Resources",
    faq: "FAQ",
    contact: "Contact",
  },
};
